import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DeviceDashboardPageComponent } from './device-dashboard-page.component';

const routes: Routes = [
  {
    path: 'device-dashboard-page',
    data: { name: 'Dashboard', isTab: false },
    component: DeviceDashboardPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceDashboardPageRoutingModule {}
